/**
 * google.type.Date を M/D 形式の短い表示文字列に変換する。
 *
 * 引数は month / day だけを見るため、proto の `Date` と editState が持つ素の
 * `{year, month, day}` の双方をそのまま渡せるように構造型で受ける。
 */
export function protoDateToShortLabel(d: {
  month: number
  day: number
}): string {
  return `${d.month}/${String(d.day).padStart(2, '0')}`
}
